export function handleURLForWKT(wktInputControl) {
  const wkt = getWKTURL();
  if (wkt != null && wkt != "") {
    // If the URL has no center/zoom, zoom to the WKT extent so the feature
    // is visible. When the URL also specifies a view, respect it instead.
    const params = new URLSearchParams(window.location.search);
    if (!params.get("center") || !params.get("zoom")) {
      wktInputControl.set("zoomToExtent", true);
    }
    wktInputControl.set("wkt", wkt);
  }
}
export function handleURLForDate(dateInputControl) {
  if (getStartDateURL() != null && getEndDateURL() != null) {
    dateInputControl.setProperties({
      startDate: getStartDateURL(),
      endDate: getEndDateURL(),
    });
  }
}

function getWKTURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("wkt");
}

function getStartDateURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("startDate");
}

function getEndDateURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("endDate");
}
